<script setup lang="ts">
import { ref, watch } from "vue"
import { GDialog } from 'gitart-vue-dialog'

type Props = {
  modalState: boolean,
  title?: string,
  titleClass?: string,
  subTitle?: string,
  subTitleClass?: string,
  note?: string,
  noteClass?: string,
  btnName?: string | null,
  btnClass?: string,
  modalMaxWidth?: string,
  loading?: boolean,
};
const props = withDefaults(defineProps<Props>(), {
  modalState: false,
  title: '',
  btnName: 'OK',
  titleClass: 'confirmation-modal-title',
  subTitleClass: 'confirmation-modal-subtitle',
  noteClass: 'confirmation-modal-note',
});
const localModalState = ref(false)

watch(() => props.modalState, (value) => {
  localModalState.value = value
})

const emits = defineEmits(['click'])

function click() {
  emits("click");
  localModalState.value = false
}
</script>

<style scope>
</style>

<template>
  <GDialog
    v-model="localModalState"
    :max-width="props.modalMaxWidth"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-header justify-content-center mt-2">
      <label :class="props.titleClass">{{ title }}</label>
    </div>

    <div class="modal-body mx-4">
      <label :class="props.subTitleClass">{{ subTitle }}</label>
      <slot name="supplementary-item" />

      <div :class="props.noteClass">
        <slot name="note">
          {{ note }}
        </slot>
      </div>
    </div>

    <div class="d-flex justify-content-end m-3 mt-4">
      <v-btn
        class="ma-2 reset-btn"
        :class="btnClass"
        @click="click"
      >
        {{btnName}}
      </v-btn>
    </div>
  </GDialog>
</template>
